import type { ReactNode } from 'react';

/** Shared with the `pendingComponent` skeletons (page-pending.tsx), so the two cannot drift apart. */

const PAGE_MAX_WIDTH = 'mx-auto w-full max-w-[1366px]';

export const BACK_LINK_ROW_CLASS = 'mb-1 px-5 py-4 sm:mb-0 sm:p-6';

export const LEGAL_CONTENT_CLASS = 'mx-auto max-w-4xl p-8';

export function HomeLayout(props: { children: ReactNode }) {
	return <div className="flex min-h-svh w-full">{props.children}</div>;
}

export function HomeMain(props: { children: ReactNode }) {
	return <main className="flex min-w-0 flex-1 flex-col">{props.children}</main>;
}

export function HeroSection(props: { children: ReactNode }) {
	return <section className={PAGE_MAX_WIDTH}>{props.children}</section>;
}

export function CampaignsSection(props: { children: ReactNode }) {
	return (
		<div id="campaigns" className="bg-secondary border-border flex-1 border-t">
			<div className="mx-auto flex max-w-[1366px] flex-col gap-6 px-5 py-8 sm:px-6 sm:py-16 lg:gap-12 lg:py-24">
				{props.children}
			</div>
		</div>
	);
}

/* One wrapper, so the sticky donate button shares its DOM level and never shows white-on-grey. */
export function CampaignLayout(props: { children: ReactNode }) {
	return <div className="bg-secondary">{props.children}</div>;
}

export function CampaignTopSection(props: { children: ReactNode }) {
	return <div className="bg-background pb-2 sm:pb-6">{props.children}</div>;
}

export function CampaignBackNav(props: { children: ReactNode }) {
	return <nav className={PAGE_MAX_WIDTH}>{props.children}</nav>;
}

export function CampaignBottomSection(props: { children: ReactNode }) {
	return <div className="bg-secondary border-border border-t">{props.children}</div>;
}

export function CampaignColumns(props: { children: ReactNode }) {
	return (
		<main className="mx-auto flex w-full max-w-[1366px] flex-col-reverse gap-6 px-5 pt-5 pb-6 sm:gap-12 sm:px-6 sm:pt-6 lg:flex-row lg:gap-24 lg:pb-16">
			{props.children}
		</main>
	);
}

export function LegalLayout(props: { children: ReactNode }) {
	return <main className="w-full">{props.children}</main>;
}
